import { useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

export const VIEWER_PROPERTIES_QUERY = gql`
    query {
        properties {
            id
            recordId
            activatedAt
            activations
            density
            description
            expiresAt
            lat
            lng
            location
            manager {
                recordId
                firstName
                lastName
                company {
                    recordId
                }
            }
            photos {
                id
                recordId
                isCoverPhoto
                url
            }
            purpose
            sitePlan {
                id
                recordId
                url
            }
            size
            title
            typeOfCenter
            typeOfFacility
            url
            createdAt
            updatedAt
            #     businesses
            #     contacts
            #     events
            #     owner
        }
    }
`;

const useViewerProperties = (options = {}) => {
    const [properties, setProperties] = useState();
    const { data, ...rest } = useQuery(VIEWER_PROPERTIES_QUERY, options);

    useEffect(() => {
        if (!data) {
            return;
        }

        setProperties(data.properties);
    }, [data]);

    return { data: properties, ...rest };
};

export default useViewerProperties;
